// extracted by mini-css-extract-plugin
var _1 = "ControlBarPopOver-module__animateUploadProgressBarWidth--R_jz2";
var _2 = "ControlBarPopOver-module__animatedBackground--FXDY6";
var _3 = "ControlBarPopOver-module__arrowBg--D0C8y";
var _4 = "ControlBarPopOver-module__arrowStroke--Pxlxl";
var _5 = "ControlBarPopOver-module__floatingContainer--kO0Rp";
var _6 = "ControlBarPopOver-module__inner--_xjHy";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "arrowBg", _4 as "arrowStroke", _5 as "floatingContainer", _6 as "inner" }
